export const formatPhone = (phone: string) => {
  const mobilePhone = phone?.length < 10 ? 0 + phone : phone
  return mobilePhone
    ? mobilePhone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    : '-'
}
